import { Immutable } from "immer";
import React from "react";

import type { UtilityLeftSideBarList as Value } from "@reactivated";

import { getLinkUrl } from "../../utils/wagtail";

import styles from "./index.module.scss";

type IProps = Immutable<{
    value: Value;
}>;

/**
 * sealy's left side-nav-bar list, rendered natively in-tree by PageSkeleton for
 * the full-document UtilityPage.
 *
 * Each link's url resolves through ``getLinkUrl`` (mirrors ``LinkValue.get_url``:
 * chosen page wins, else ``external_url``, else "").
 */
export const UtilityLeftSideBarList = (props: IProps): React.JSX.Element => {
    return (
        <nav className={styles.listGroup}>
            <h2 className={styles.listGroupHeader}>
                {props.value.title ?? ""}
            </h2>
            <ul className={styles.listGroupLinks}>
                {(props.value.links ?? []).map((link, index) => (
                    <li className={styles.listGroupItem} key={index}>
                        <a
                            href={getLinkUrl(link)}
                            {...(link.open_in_new_tab
                                ? { target: "_blank" }
                                : {})}
                            title={link.html_title ?? ""}
                        >
                            {link.display_name ?? ""}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    );
};
